import React from 'react'
import { RateInput } from 'components/template/TemplateForm'
import ErrorMessage from 'components/common/ErrorMessage'

const TranslationTiers = ({ languageTiers, control, errors, item }) => {
  return (
    <>
      {languageTiers && languageTiers?.map((val, index) => {
        return (
          <React.Fragment key={`translation-tier-${index}`}>
            <div className="row-primary mt-3 mb-5 justify-content-center">
              <h2 className='fw-bold text-center text-uppercase'>Translation Rates</h2>
            </div>
            <div className='row-primary rate_container_outer'>
              <h2 className='fw-bold text-uppercase'>{val?.name || val?.tiers[0]?.name || 'N/A'}</h2>

              <div className='rate_container_wrapper w-100'>
                <div className='template_create rate_container'>
                  <div className="row-primary align-items-end inner">
                    <h2 className='mb-3 my-0'>Rates</h2>

                    <div className='Inter_rate_row'>
                      <h4 className='text-center fw-bold fst-italic'>Translation</h4>
                      <span className='static-unit-text'>per word</span>
                      <div className='create inter_wrapper translation_rate_input'>
                        <RateInput control={control} name={`translationRates.translation_rate.${index}`} placeholder='Translation rate' currency_symbol={true} />
                      </div>
                    </div>

                    <div className='Inter_rate_row'>
                      <h4 className='text-center fw-bold fst-italic'>Editing</h4>
                      <span className='static-unit-text'>per word</span>
                      <div className='create inter_wrapper translation_rate_input'>
                        <RateInput control={control} name={`translationRates.editing_rate.${index}`} placeholder='Editing rate' currency_symbol={true} />
                      </div>
                    </div>

                    <div className='Inter_rate_row'>
                      <h4 className='text-center fw-bold fst-italic'>DTP</h4>
                      <span className='static-unit-text'>per work</span>
                      <div className='create inter_wrapper translation_rate_input'>
                        <RateInput control={control} name={`translationRates.dtp_rate.${index}`} placeholder='DTP rate' currency_symbol={true} />
                      </div>
                    </div>

                    {/* <div className='Inter_rate_row'>
                      <h4 className='text-center fw-bold fst-italic'>Review</h4>
                      <span className='static-unit-text'>per page</span>
                      <div className='create inter_wrapper'>
                        <RateInput control={control} name={`translationRates.review_rate.${index}`} placeholder='Review rate' currency_symbol={true} />
                      </div>
                    </div> */}
                  </div>

                  <div className="row-primary align-items-end inner">
                    <h2 className='mb-3 my-0'>Rates</h2>

                    <div className='Inter_rate_row'>
                      <h4 className='text-center fw-bold fst-italic'>Review</h4>
                      <span className='static-unit-text'>per page</span>
                      <div className='create inter_wrapper translation_rate_input'>
                        <RateInput control={control} name={`translationRates.review_rate.${index}`} placeholder='Review rate' currency_symbol={true} />
                      </div>
                    </div>

                    <div className='Inter_rate_row'>
                      <h4 className='text-center fw-bold fst-italic'>Audio Recording</h4>
                      <span className='static-unit-text'>per word</span>
                      <div className='create inter_wrapper translation_rate_input'>
                        <RateInput control={control} name={`translationRates.audio_recording_rate.${index}`} placeholder='Audio Recording rate' currency_symbol={true} />
                      </div>
                    </div>

                    <div className='Inter_rate_row'>
                      <h4 className='text-center fw-bold fst-italic'>Transcription</h4>
                      <span className='static-unit-text'>per audio minute</span>
                      <div className='create inter_wrapper translation_rate_input'>
                        <RateInput control={control} name={`translationRates.transcription_rate.${index}`} placeholder='Transcription rate' currency_symbol={true} />
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )
      })}
    </>
  )
}

export default TranslationTiers
